class LangPopup extends HTMLElement {
  constructor() {
    super();

    this.closeButton = this.querySelector("#lang-popup-close");
    this.content = this.querySelector("#lang-popup-content");
    this.form = this.querySelector("form");
    this.langPopupBtn = document.querySelector("#tr-lang-popupBtn");

    console.log("🔍 CONSTRUCTOR: Classes initiales de la popup:", this.classList.toString());

    this.langSuggestion();
  }

  connectedCallback() {
    console.log("🔍 CONNECTED: Classes de la popup à la connexion:", this.classList.toString());

    if (this.closeButton) {
      this.closeButton.addEventListener("click", this.close.bind(this));
    }

    // Ajout de l'écouteur pour le bouton d'ouverture
    if (this.langPopupBtn) {
      this.langPopupBtn.addEventListener("click", this.open.bind(this));
    }

    if (this.langPopupBtnMobile) {
      this.langPopupBtnMobile.addEventListener("click", this.open.bind(this));
    }

    // Gestion du clic en dehors du contenu
    document.addEventListener("click", (event) => {
      if (this.classList.contains("lang-popup--open") && !this.content.contains(event.target) && !this.langPopupBtn?.contains(event.target) && !this.langPopupBtnMobile?.contains(event.target)) {
        this.close();
      }
    });

    // Gestion du formulaire
    if (this.form) {
      this.form.addEventListener("submit", this.onSubmit.bind(this));
    }

    // Afficher la popup automatiquement si nécessaire
    this.showLangPopup();
  }

  // Open the lang popup
  open() {
    console.log("🚀 OUVERTURE POPUP - Appelée depuis:", new Error().stack);
    this.classList.add("lang-popup--open");
    console.log("🚀 POPUP OUVERTE - Classes après ouverture:", this.classList.toString());
  }

  // Close the lang popup
  close() {
    console.log("❌ FERMETURE POPUP");
    this.classList.remove("lang-popup--open");
    console.log("❌ POPUP FERMÉE - Classes après fermeture:", this.classList.toString());
  }

  // Get the lang suggestion
  async langSuggestion() {
    return await fetch(window.Shopify.routes.root + "browsing_context_suggestions.json" + "?country[enabled]=true" + `&country[exclude]=${window.Shopify.country}` + "&language[enabled]=true" + `&language[exclude]=${window.Shopify.locale}`).then((r) => r.json());
  }

  // Show lang popup if there is a lang suggestion different from the current lang
  showLangPopup() {
    console.log("=== DEBUT DEBUG POPUP LANG ===");
    console.log("Pays actuel:", window.Shopify.country);
    console.log("Langue actuelle:", window.Shopify.locale);

    // Vérifier si le localStorage existe déjà
    const popupAlreadyShown = localStorage.getItem("lang_popup_shown");
    console.log("Popup déjà montrée?", popupAlreadyShown);

    if (popupAlreadyShown) {
      console.log("❌ Popup déjà montrée, on ne l'affiche pas");
      return;
    }

    this.langSuggestion()
      .then((response) => {
        console.log("Réponse API suggestions:", response);

        if (response.suggestions.length > 0) {
          console.log("✅ Suggestions trouvées:", response.suggestions.length);

          //Langue suggestions
          const suggestedLanguage = response.suggestions[0].parts.language ? response.suggestions[0].parts.language.handle : null;
          const currentLocale = window.Shopify.locale;

          console.log("Langue suggérée:", suggestedLanguage);
          console.log("Langue actuelle:", currentLocale);
          console.log("Langues différentes?", suggestedLanguage !== currentLocale);

          // Si la langue suggérée est différente de la langue actuelle
          if (suggestedLanguage !== currentLocale) {
            console.log("🚀 OUVERTURE POPUP: Langue différente");
            this.open();
            return;
          }

          //Pays suggestions
          const suggestedCountry = response.suggestions[0].parts.country ? response.suggestions[0].parts.country.handle : null;
          const currentCountry = window.Shopify.country;

          console.log("Pays suggéré:", suggestedCountry);
          console.log("Pays actuel:", currentCountry);
          console.log("Pays différents?", suggestedCountry !== currentCountry);

          if (suggestedCountry !== currentCountry) {
            console.log("🚀 OUVERTURE POPUP: Pays différent");
            this.open();
          } else {
            console.log("✅ Pas de différence détectée, popup reste fermée");
          }
        } else {
          console.log("❌ Aucune suggestion trouvée");
        }

        console.log("=== FIN DEBUG POPUP LANG ===");
      })
      .catch((error) => {
        console.error("Erreur lors de la récupération des suggestions:", error);
      });
  }

  // On submit the lang popup
  onSubmit(event) {
    event.preventDefault();

    if (this.form) {
      console.log("📤 Soumission du formulaire de localisation");

      // Utiliser localStorage au lieu du cookie
      localStorage.setItem("lang_popup_shown", "true");

      // Fermer la popup
      this.close();

      // Soumettre le formulaire
      this.form.submit();
    }
  }
}

// Définir le custom element
customElements.define("lang-popup", LangPopup);

// Classe pour gérer le formulaire de localisation
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    console.log("🔍 LocalizationForm - Version simple avec selects");
  }

  connectedCallback() {
    // Pas besoin de logique spéciale, les selects fonctionnent nativement
    console.log("✅ LocalizationForm connecté");
  }
}

// Définir le custom element
customElements.define('localization-form', LocalizationForm);
